const TOKENS_LIST =
  "https://raw.githubusercontent.com/ArrakisFinance/community-data/main/tokensList.json";

export async function fetchTokensList() {
  const response = await fetch(TOKENS_LIST);
  const data = await response.json();
  return data;
}
